import styled from 'styled-components';
import { MainRowColumns } from './types';

export const MainRow = styled.div<{ $columns: MainRowColumns }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns.tablet};
  gap: 8px;
  align-items: end;

  &[data-layout='table'] {
    grid-template-columns: ${({ $columns }) => $columns.table} auto;
  }

  &[data-layout='desktop'] {
    grid-template-columns: ${({ $columns }) => $columns.desktop} auto;
    gap: 12px;
  }

  > * {
    min-width: 0;
  }

  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-select,
  .ant-picker {
    width: 100%;
  }
`;

export const Icons = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-bottom: 12px;

  &[data-layout='tablet'] {
    grid-column: 1 / -1;
  }
`;

export const ActiveHint = styled.span`
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  color: #d16d0f;
  text-align: right;
`;

export const AdvancedBox = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0 12px;
  align-items: start;
  padding: 16px 16px 4px;
  margin: 4px 0 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  &[hidden] {
    display: none;
  }

  > * {
    min-width: 0;
  }

  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-select,
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
`;

export const PanelFields = styled.div`
  padding: 16px 16px 0;

  .ant-select,
  .ant-picker,
  .ant-input {
    width: 100%;
  }
`;

export const SheetFields = styled.div`
  padding-top: 4px;

  &[data-inline-actions='true'] {
    padding-bottom: 5px;
  }

  .ant-form-item {
    margin-bottom: 14px;
  }

  .ant-select,
  .ant-picker,
  .ant-input {
    width: 100%;
    min-height: 44px;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 44px;
    align-items: center;
  }
`;

export const AdvancedToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 0;
  margin-bottom: 8px;
  font: inherit;
  font-weight: 700;
  color: #262626;
  cursor: pointer;
  background: none;
  border: none;
  border-top: 1px solid #d9d9d9;
`;

export const ActiveCount = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #595959;
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 8px;

  &[data-even='true'] {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ActionButton = styled.button`
  height: 44px;
  padding: 0 16px;
  font: inherit;
  font-weight: 500;
  color: #262626;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  &[data-primary='true'] {
    color: #000;
    background: #f78e1e;
    border-color: #f78e1e;
  }
`;

export const InlineActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  margin: 4px 0 12px;

  ${ActionButton} {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: 0 8px;
  }
`;
